import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form as FinalForm, Field } from 'react-final-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { OnChange } from 'react-final-form-listeners';

import { composeValidators, required, isEmail } from '../../../utils/validators';
import * as userActions from '../../../state/modules/user/actions';

import Form from '../../Form';
import InputField from '../../InputField';
import PhoneField from '../../PhoneField';
import RadioField from '../../RadioField';

import Actions from '../../Actions';
import Button from '../../Button';
import FieldError from '../../FieldError';

const ConditionField = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => (value === is ? children : null)}
  </Field>
);

const WhenFieldChanges = ({ field, becomes, set, to }) => (
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } },
    ) => (
      <OnChange name={field}>
        {value => {
          if (value === becomes) {
            onChange(to);
          }
        }}
      </OnChange>
    )}
  </Field>
);

class RecoveryPasswordFirstStepForm extends PureComponent {
  static defaultProps = {
    error: '',
    phone: '',
    email: '',
  };

  static propTypes = {
    error: PropTypes.string,
    recoveryPasswordSendConfirmCode: PropTypes.func.isRequired,
    codeIsSending: PropTypes.bool.isRequired,
    codeIsSended: PropTypes.bool.isRequired,
    rememberPhone: PropTypes.func.isRequired,
    rememberEmail: PropTypes.func.isRequired,
    recoveryPasswordSendConfirmCodeReset: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    phone: PropTypes.string,
    email: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.radioPhoneRef = React.createRef();
    this.radioEmailRef = React.createRef();
  }

  componentWillMount() {
    if (this.props.codeIsSended) {
      this.props.recoveryPasswordSendConfirmCodeReset();
    }
  }

  componentWillReceiveProps({ codeIsSended }) {
    if (codeIsSended) {
      this.props.onNext();
    }
  }

  initialValues = {
    type: 'mail_recovery_password',
    phone: this.props.phone,
    email: this.props.email,
  };

  // Очищаем поля и ошибки валидации при переключении радио-кнопок
  clearField = _currentRef => {
    const { phone, email } = this.initialValues;
    const { value } = _currentRef.current.props;

    const _init = {
      phone,
      email,
      type: value,
    };

    // Сбрасываем форму
    this.formRef.current.form.reset(_init);

    // Сбрасываем ошибки submit'a
    if (this.props.error) {
      this.props.clearUserErrors('recoveryPassword');
    }
  };

  handleSubmit = ({ phone, email, type }) => {
    if (type === 'mail_recovery_password') {
      this.props.rememberEmail(email);
      this.props.rememberPhone('');
      return this.props.recoveryPasswordSendConfirmCode({ email, type });
    } else {
      this.props.rememberPhone(phone);
      this.props.rememberEmail('');
      return this.props.recoveryPasswordSendConfirmCode({ phone, type });
    }
  };

  render() {
    return (
      <div>
        <FinalForm
          ref={this.formRef}
          initialValues={this.initialValues}
          onSubmit={this.handleSubmit}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              {/*<WhenFieldChanges*/}
              {/*  field="recovery_password"*/}
              {/*  becomes={false}*/}
              {/*  set="phone"*/}
              {/*  to={undefined}*/}
              {/*/>*/}
              <WhenFieldChanges
                field="mail_recovery_password"
                becomes={false}
                set="email"
                to={undefined}
              />
              <Form.Row>
                {/*<Field name="type" type="radio" value="recovery_password" ref={this.radioPhoneRef}>*/}
                {/*  {({ input }) => (*/}
                {/*    <Form.Field width="one-half">*/}
                {/*      <FormattedMessage id="field.phone.label">*/}
                {/*        {label => (*/}
                {/*          <RadioField*/}
                {/*            {...input}*/}
                {/*            label={label}*/}
                {/*            onChange={e => {*/}
                {/*              input.onChange(e);*/}
                {/*              this.clearField(this.radioPhoneRef);*/}
                {/*            }}*/}
                {/*          />*/}
                {/*        )}*/}
                {/*      </FormattedMessage>*/}
                {/*    </Form.Field>*/}
                {/*  )}*/}
                {/*</Field>*/}
                <Field
                  name="type"
                  type="radio"
                  value="mail_recovery_password"
                  ref={this.radioEmailRef}
                >
                  {({ input }) => (
                    <Form.Field width="one-half">
                      <RadioField
                        {...input}
                        label="Email"
                        onChange={e => {
                          input.onChange(e);
                          this.clearField(this.radioEmailRef);
                        }}
                      />
                    </Form.Field>
                  )}
                </Field>
              </Form.Row>
              <ConditionField when="type" is="recovery_password">
                <Field name="phone" validate={required}>
                  {({ meta, input }) => (
                    <Form.Field>
                      <FormattedMessage id="recoveryPassword.type.phone">
                        {label => <PhoneField {...input} label={label} />}
                      </FormattedMessage>
                      <FieldError name="phone" />
                      <Form.Error {...meta} error={this.props.error} />
                    </Form.Field>
                  )}
                </Field>
              </ConditionField>
              <ConditionField when="type" is="mail_recovery_password">
                <Field name="email" validate={composeValidators(required, isEmail)}>
                  {({ meta, input }) => (
                    <Form.Field>
                      <InputField {...input} type="email" label="Email" />
                      <FieldError name="email" />
                      <Form.Error {...meta} error={this.props.error} />
                    </Form.Field>
                  )}
                </Field>
              </ConditionField>
              <Actions>
                <Button onClick={this.props.onCancel} link>
                  <FormattedMessage id="button.cancel" />
                </Button>
                <Button type="submit" isLoading={this.props.codeIsSending}>
                  <FormattedMessage id="button.continue" />
                </Button>
              </Actions>
            </Form>
          )}
        />
      </div>
    );
  }
}

const connector = connect(
  ({ user: { recoveryPassword } }) => ({ ...recoveryPassword }),
  dispatch => bindActionCreators(userActions, dispatch),
);

export default connector(RecoveryPasswordFirstStepForm);
